import { FC } from 'react';
import { ModalFooter } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

export interface EmailServiceModalActionsProps {
  canSubmit: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

// TODO: Unit test
export const EmailServiceModalActions: FC<EmailServiceModalActionsProps> = ({ canSubmit, onCancel, onSubmit }) => {
  return (
    <ModalFooter className="btn-grp">
      <button className="btn btn-xl btn-default flex-fill" onClick={onCancel}>
        <FormattedMessage id="cancel" />
      </button>
      <button className="btn btn-xl btn-primary btn-icon-end flex-fill" disabled={!canSubmit} onClick={onSubmit}>
        <FormattedMessage id="send" />
        <i className="icon">send</i>
      </button>
    </ModalFooter>
  );
};
